import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";

/**
 * JOB INCOMING vs OUTGOING
 *
 * Month by month: items received for repair against repaired items dispatched.
 * When the blue bar keeps running ahead of the green one, work is piling up -
 * that single read is the point of this chart.
 */
const JobFlowChart = ({ trend = [], loading = false }) => {
  const series = [
    { name: "Incoming", data: trend.map((t) => t.incoming) },
    { name: "Outgoing", data: trend.map((t) => t.outgoing) },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "inherit",
      stacked: false,
    },
    plotOptions: {
      bar: { borderRadius: 3, columnWidth: "45%" },
    },
    colors: ["#5664d2", "#1cbb8c"],
    dataLabels: { enabled: false },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    grid: { borderColor: "#f1f1f1" },
    xaxis: { categories: trend.map((t) => t.label) },
    yaxis: {
      title: { text: "No. of Jobs", style: { fontWeight: 500 } },
      labels: { formatter: (val) => Math.round(val) },
    },
    legend: { position: "top", horizontalAlign: "right", markers: { radius: 3 } },
    tooltip: { shared: true, intersect: false },
  };

  return (
    <Card>
      <CardBody>
        <div className="mb-3">
          <h5 className="card-title mb-1">Job Incoming vs Outgoing</h5>
          <p className="text-muted font-size-12 mb-0">
            Last 12 months - received for repair against dispatched
          </p>
        </div>

        {loading ? (
          <div className="dashboard-placeholder">Loading...</div>
        ) : trend.length === 0 ? (
          <div className="dashboard-placeholder text-muted">
            No job movement recorded yet.
          </div>
        ) : (
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={260}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default JobFlowChart;
